import { render } from "./toggle.vue?vue&type=template&id=3c5e890e&scoped=true&ts=true"
import script from "./toggle.vue?vue&type=script&lang=ts"
export * from "./toggle.vue?vue&type=script&lang=ts"

import "./toggle.vue?vue&type=style&index=0&id=3c5e890e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5e890e"]])

export default __exports__